import { writable } from 'svelte/store';
const TIMEOUT = 3000;
function generateId() {
    return '_' + Math.random().toString(36).substr(2, 9);
}
const meet = {};
function createNotificationStore() {
    const notifications = writable([]);
    function send(message, type = 'default', timeout = TIMEOUT) {
        if (meet[message] === undefined) {
            meet[message] = true;
            const id = generateId();
            notifications.update(state => {
                return [...state, { id, type, message }];
            });
            setTimeout(() => {
                notifications.update((all) => all.filter((t) => t.id !== id));
                delete meet[message];
            }, timeout);
        }
    }
    const { subscribe } = notifications;
    return {
        subscribe,
        default: (msg, timeout) => send(msg, 'default', timeout),
        success: (msg, timeout) => send(msg, 'success', timeout),
        warning: (msg, timeout) => send(msg, 'warning', timeout),
        error: (msg, timeout) => send(msg, 'error', timeout),
    };
}
export const notifications = createNotificationStore();
